// TODO: move product scripts in folder
import {isMobile} from '@/app/js/helpers/is-mobile'

export function initProductVideo()
{
  const videoEl = document.querySelector('.js-product-video')

  if (!videoEl) {
    return
  }

  if (!isMobile()) {
    videoEl.play()
  }
}
